import { useEffect, useMemo, useState } from "react";
import { useAlertContext } from "../../../../../contexts/alert/AlertProvider";
import { useBackdropContext } from "../../../../../contexts/backdrop/BackdropProvider";
import {
  asyncPostData,
  asyncPutData,
  asyncSearchList,
} from "../../../../../utils/httpRequests";
import {
  ADD_RIGHT,
  DELETE_RIGHT,
  UPDATE_RIGHT,
  VIEW_RIGHT,
  VIEWOFOTHER_RIGHT,
} from "../../../../../utils/constants";
import { Box, Grid2, Stack } from "@mui/material";
import { useSelector } from "react-redux";
import CheckboxInput from "../../../input/CheckboxInput";
import CheckBoxComponent from "./CheckboxComponent";

interface IModuleComponent {
  module: any;
  rightObj: any;
  userGroup: any;
  getRights: () => void;
}

const allRight: string[] = [
  VIEW_RIGHT,
  VIEWOFOTHER_RIGHT,
  ADD_RIGHT,
  UPDATE_RIGHT,
  DELETE_RIGHT,
];

function ModuleComponent({
  module,
  rightObj,
  userGroup,
  getRights,
}: IModuleComponent) {
  const { token } = useSelector((state: any) => state.auth);
  const { showAlert } = useAlertContext();
  const { setOpenBackdrop } = useBackdropContext();

  const [trangThais, setTrangThais] = useState<any[]>([]);

  const addOrUpdateRight = async ({
    type,
    value,
  }: {
    type: string;
    value: boolean;
  }) => {
    setOpenBackdrop?.(true);
    if (!!currentRight) {
      const resp = await asyncPutData({
        apiCode: "right",
        token,
        id: currentRight._id,
        data: { [type]: value, email: userGroup._id, module: module.code },
      });
      if (!resp || resp?.status !== 200) {
        showAlert({
          type: "error",
          message: resp?.data?.message || resp?.data?.error || "Có lỗi xảy ra",
        });
      } else {
        await getRights();
      }
    } else {
      const resp = await asyncPostData({
        apiCode: "right",
        token,
        data: { [type]: value, email: userGroup._id, module: module.code },
      });
      if (!resp || resp?.status !== 200) {
        showAlert({
          type: "error",
          message: resp?.data?.message || resp?.data?.error || "Có lỗi xảy ra",
        });
      } else {
        await getRights();
      }
    }
    setOpenBackdrop?.(false);
  };

  const handleTotalCheck = async (check: boolean) => {
    setOpenBackdrop?.(true);
    try {
      if (!currentRight) {
        const resp = await asyncPostData({
          apiCode: "right",
          token,
          data: {
            [VIEW_RIGHT]: check,
            email: userGroup._id,
            module: module.code,
          },
        });
        const rights =
          resp?.data?.module === "participant"
            ? [ADD_RIGHT, UPDATE_RIGHT, DELETE_RIGHT]
            : [VIEWOFOTHER_RIGHT, ADD_RIGHT, UPDATE_RIGHT, DELETE_RIGHT];
        for (let i = 0; i < rights.length; i++) {
          await asyncPutData({
            apiCode: "right",
            id: resp?.data?._id,
            token,
            data: {
              [rights[i]]: check,
              email: userGroup._id,
              module: module.code,
            },
          });
        }
      } else {
        for (let i = 0; i < allRight.length; i++) {
          await asyncPutData({
            apiCode: "right",
            token,
            id: currentRight._id,
            data: {
              [allRight[i]]: check,
              email: userGroup._id,
              module: module.code,
            },
          });
        }
      }
      await getRights();
    } catch (error: any) {
      showAlert({
        type: "error",
        message: error?.message || "Something went wrong!",
      });
    } finally {
      setOpenBackdrop?.(false);
    }
  };

  // get trang thai
  const getTrangThai = async () => {
    const resp = await asyncSearchList({
      apiCode: "trangthai",
      withIdApp: false,
      condition: { page: 1, limit: 90000, q: { ma_ct: module.code } },
    });
    setTrangThais(resp);
  };

  const currentRight = useMemo(() => {
    const res = rightObj[module.code] || null;
    return res;
  }, [module.code, rightObj]);

  const totalCheck = useMemo(() => {
    return (
      !!currentRight &&
      currentRight[VIEW_RIGHT] &&
      currentRight[VIEWOFOTHER_RIGHT] &&
      currentRight[ADD_RIGHT] &&
      currentRight[UPDATE_RIGHT] &&
      currentRight[DELETE_RIGHT]
    );
  }, [currentRight]);

  useEffect(() => {
    getTrangThai();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [module.code]);

  return (
    <Box sx={{ padding: 1, border: "1px solid", borderColor: "divider" }}>
      <Stack direction="row" gap={1} sx={{ width: "100%" }}>
        <CheckboxInput
          label={module.title}
          checked={totalCheck}
          wrapperSx={{
            "& .MuiFormControlLabel-root": {
              "& .MuiTypography-root": { fontWeight: 800 },
            },
          }}
          onChange={() => handleTotalCheck(!totalCheck)}
        />
      </Stack>
      <Grid2 container>
        {module.rights.map((right: string) => (
          <CheckBoxComponent
            key={right}
            right={right}
            module={module}
            addOrUpdateRight={addOrUpdateRight}
            currentRight={currentRight}
            trangThais={trangThais}
          />
        ))}
      </Grid2>
    </Box>
  );
}
export default ModuleComponent;
